import { Box, CardContent, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { isEmpty } from '../../../../helpers/utilityFunctions/utilityFunctions';
import { ParameterCard } from '../../../documented/ParameterCard';
import { ReactComponent as Background } from './averageCycleDurationBackground.svg';
import { AverageCycleDurationCardData } from './averageCycleDurationCardData';

interface AverageCycleDurationCardProps {
  data?: AverageCycleDurationCardData;
  onClick: (arg: string) => void;
}

const CardDetailTypography = styled(Typography)(() => ({
  fontSize: 14,
  padding: '0px 0px 0px 16px !important',
}));

const AverageCycleDurationCardMedia = styled(CardContent)(() => ({
  display: 'flex !important',
  flexDirection: 'column',
  flexGrow: '1 !important',
}));

const PanelDisplayBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
}));

const AverageCycleDurationCard: React.FC<AverageCycleDurationCardProps> = ({
  data,
  onClick,
}: AverageCycleDurationCardProps) => {
  const { t } = useTranslation('cards');
  return (
    <ParameterCard
      title={t('averageCycleDuration.title')}
      iconName="AverageCycleDuration"
      onClick={() => onClick('_10MWT')}
      enabled={!isEmpty(data)}
    >
      <CardDetailTypography>
        {t('averageCycleDuration.description')}
      </CardDetailTypography>
      <AverageCycleDurationCardMedia>
        <PanelDisplayBox>
          <Box
            sx={{
              position: 'relative', // Establishes stacking context for layering
              height: 206.148,
              width: 173,
            }}
          >
            {/* SVG Background Component */}
            <Background
              style={{
                position: 'absolute', // Places the SVG at the bottom layer
                top: 0,
                left: 0,
                height: '100%',
                width: '100%',
                zIndex: 1, // Ensures it stays behind other elements
              }}
            />

            {/* Grid Container for Overlays */}
            <Grid
              sx={{
                position: 'absolute', // Positions typography over the background
                height: '100%',
                width: '100%',
                direction: 'column',
                alignItems: 'center',
                justifyContent: 'space-between',
                zIndex: 2, // Ensures it's above the background
              }}
              container
            >
              {/* Left Typography Grid */}
              <Grid

                sx={{
                  width: '86.5px',
                  display: 'flex',
                  flexDirection: 'column',
                  margin: '0px 0px 0px -25px',
                }}
              >
                <Typography
                  sx={{ fontWeight: 'bold', fontSize: 20, textAlign: 'center' }}
                >
                  {data ? Number(data.left.value) : 0}
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 'bold',
                    fontSize: 20,
                    textAlign: 'center',
                  }}
                >
                  {data ? data.unit : '0'}
                </Typography>
              </Grid>

              {/* Right Typography Grid */}
              <Grid

                sx={{
                  width: '86.5px',
                  display: 'flex',
                  flexDirection: 'column',
                  margin: '0px -25px 0px 0px',
                }}
              >
                <Typography
                  sx={{ fontWeight: 'bold', fontSize: 20, textAlign: 'center' }}
                >
                  {data ? Number(data.right.value) : 0}
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 'bold',
                    fontSize: 20,
                    textAlign: 'center',
                  }}
                >
                  {data ? data.unit : '0'}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </PanelDisplayBox>
      </AverageCycleDurationCardMedia>
    </ParameterCard>
  );
};

export default AverageCycleDurationCard;
